import { useParams } from "react-router-dom";
import { ProvidersPage } from "./ProvidersPage";
import { ProviderDetailPage } from "./ProviderDetailPage";

function parseProviderRouteId(raw: string | undefined): number {
  if (!raw) return NaN;
  const cleaned = raw.trim().replace(/^prov-/i, "");
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : NaN;
}

/** Liste ou fiche détail selon la présence de `:id` (même schéma que les employés). */
export function ProvidersPageRouter() {
  const { id } = useParams();
  const providerId = parseProviderRouteId(id);

  if (!Number.isNaN(providerId) && providerId > 0) {
    return <ProviderDetailPage providerId={providerId} />;
  }

  return <ProvidersPage />;
}
